import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#EFEFEF"}},[_c(VContainer,{staticClass:"py-12"},[_c(VRow,{staticClass:"text-center"},[_c(VCol,{attrs:{"cols":"12"}},[_c('h1',{staticClass:"display-2 mb-4 mt-0 font-weight-bold text-center",staticStyle:{"color":"#707070"}},[_vm._v(" PAST EVENTS ")])])],1),_c('WomensBrunch'),_c('TrackField'),_c('ServiceDay')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }